/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Pricing_AsideInputs */

const en_platform_pricing_aside = /** @type {(inputs: Platform_Pricing_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start free with a handful of clients. Move up when the schedule is full.`)
};

const pl_platform_pricing_aside = /** @type {(inputs: Platform_Pricing_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij bezpłatnie z kilkoma podopiecznymi. Przejdź wyżej, kiedy grafik się zapełni.`)
};

/**
* | output |
* | --- |
* | "Start free with a handful of clients. Move up when the schedule is full." |
*
* @param {Platform_Pricing_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_pricing_aside = /** @type {((inputs?: Platform_Pricing_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Pricing_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_pricing_aside(inputs)
	return en_platform_pricing_aside(inputs)
});